import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import SidenavUIJ, { DrawerHeader } from './SidenavUIJ';

export interface OrganizerLayoutUIJDesktopProps {
  pageBackgroundColor?: string;
  hideAppBar?: boolean;
  uiJedi?: boolean;
}

const OrganizerLayoutUIJDesktop: FC<OrganizerLayoutUIJDesktopProps> = ({
  children,
  pageBackgroundColor = '#F4F6FD',
  hideAppBar = false,
  uiJedi = false,
}) => {
  return (
    <Box display="flex">
      <SidenavUIJ hideAppBar={hideAppBar} />
      <Box
        component="main"
        style={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {!hideAppBar && <DrawerHeader />}
        <Box
          flexGrow={1}
          style={{
            backgroundColor: uiJedi ? pageBackgroundColor : undefined,
            // padding: uiJedi ? '32px 30px' : undefined,
            borderTopLeftRadius: '15px',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default OrganizerLayoutUIJDesktop;
